import React from 'react';
import { InventoryEntities } from 'client/data/models/inventory';
import { WarrantyComments } from 'site-modules/shared/components/inventory/warranty-module/warranty-item/warranty-comments/warranty-comments';
import { WarrantyShortOriginalDescriptionLine } from 'site-modules/shared/components/inventory/warranty-module/warranty-item/warranty-short-original-description-line/warranty-short-original-description-line';

export function WarrantyDetailedComments(props) {
  const { warrantyItem } = props;

  return (
    <>
      <div className="my-1">
        <WarrantyShortOriginalDescriptionLine warrantyItem={warrantyItem} />
      </div>
      <WarrantyComments warrantyItem={warrantyItem} />
    </>
  );
}

WarrantyDetailedComments.propTypes = {
  warrantyItem: InventoryEntities.WarrantyItem.isRequired,
};
